module.exports = __webpack_public_path__ + "img/G - 06.a25293c1.png";